module.exports = __webpack_public_path__ + "img/feature-tile-icon-01.6eff78b7.svg";